import {
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsServiceName as RecordGridViewServiceName,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../records/views/recordGridView";

import { machineConfigurationObjectName } from "../../machines/shared/names";
import { RecordDataSource } from "../../records/grids";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../records/grids/settings/gridSettingsService";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";

export const vsObjectName = "progressiveDefinitionMachine";

progressiveDefinitionMachineConfig.$inject = [
  RecordGridViewServiceProviderName,
];

export function progressiveDefinitionMachineConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    RecordGridViewServiceName,
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    (
      recordGridViewService: RecordGridViewService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      columnDefinitionService: ColumnDefinitionService
    ) => {
      const machineConfigurationGridConfiguration =
        recordGridViewService.getGridConfiguration(
          machineConfigurationObjectName
        )!;

      return {
        columns: [
          columnDefinitionService.getBooleanColDef({
            field: "Active",
          }),
          columnDefinitionService.getStringColDef({
            field: "Notes",
          }),
          ...machineConfigurationGridConfiguration.columns!,
        ],
        defaultSort: machineConfigurationGridConfiguration.defaultSort,
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/progressives/ProgressiveDefinitionMachine/structured",
          true
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Progressive Machines",
        nameSingular: "Progressive Machine",
      };
    },
  ]);
}
